import { createRequestConstantNames } from 'store/util/createConstants';
import cc from 'store/util/createReduxConstant';

export const [
  FETCH_PXWE_BUILDINGS,
  FETCH_PXWE_BUILDINGS_SUCCESS,
  FETCH_PXWE_BUILDINGS_FAILURE,
] = createRequestConstantNames(cc('FETCH_PXWE_BUILDINGS'));
